var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "file-grid" },
    _vm._l(_vm.fromList, function (item, index) {
      return _c("div", { key: index, staticClass: "file-grid-item" }, [
        _c(
          "div",
          {
            staticClass: "file-grid-item-box",
            class: [item.checkbox && "isSelected"],
            on: {
              mouseleave: function ($event) {
                $event.stopPropagation()
                return _vm.handleMouseLeave(index)
              },
            },
          },
          [
            _c("img", {
              staticClass: "url",
              attrs: { src: item.thumbnailStr, alt: item.old_filename },
              on: {
                mouseover: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleMouseOver(index)
                },
              },
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: item.hoverShow,
                    expression: "item.hoverShow",
                  },
                ],
                staticClass: "hover",
              },
              [
                _c(
                  "div",
                  { staticClass: "hover-box" },
                  _vm._l(
                    _vm.options.editList,
                    function (optionsItem, optionsIndex) {
                      return _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.btnHidden(optionsItem.value, item),
                              expression: "btnHidden(optionsItem.value, item)",
                            },
                          ],
                          key: optionsIndex,
                          staticClass: "hover-box-item",
                          on: {
                            click: function ($event) {
                              return _vm.handlerClick(optionsItem.value, item)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "hover-box-item-box" }, [
                            _c("img", {
                              attrs: { src: optionsItem.icon, alt: "" },
                            }),
                            _c(
                              "span",
                              {
                                class: [
                                  optionsItem.color == "default"
                                    ? "text-default"
                                    : "text-warning",
                                ],
                              },
                              [_vm._v(" " + _vm._s(optionsItem.label) + " ")]
                            ),
                          ]),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "edit" },
              [
                _c("el-checkbox", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !item.hasOwnProperty("percentage") &&
                        (item.hoverShow || item.checkbox),
                      expression:
                        "!item.hasOwnProperty('percentage') &&\n          (item.hoverShow || item.checkbox)\n          ",
                    },
                  ],
                  on: {
                    change: function ($event) {
                      return _vm.checkboxChange(item, index)
                    },
                  },
                  model: {
                    value: item.checkbox,
                    callback: function ($$v) {
                      _vm.$set(item, "checkbox", $$v)
                    },
                    expression: "item.checkbox",
                  },
                }),
              ],
              1
            ),
            _c("fileEditDropdown", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: item.hoverShow,
                  expression: "item.hoverShow",
                },
              ],
              staticClass: "edit-dropdown",
              attrs: { item: item, type: "grid" },
              on: {
                fileChange: _vm.fileChange,
                pushUserMd5: _vm.pushUserMd5,
                cancelDownload: _vm.cancelDownload,
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "file-grid-item-text" }, [
          _c(
            "span",
            {
              staticClass: "name ellipsis",
              attrs: { title: item.old_filename },
            },
            [_vm._v(_vm._s(item.old_filename))]
          ),
          _c("span", { staticClass: "size" }, [_vm._v(_vm._s(item.sizeStr))]),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: item.hasOwnProperty("percentage"),
                expression: "item.hasOwnProperty('percentage')",
              },
            ],
            staticClass: "file-grid-item-state",
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("uploading")) +
                "，" +
                _vm._s(item.percent || 0) +
                "% "
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: item.fileStateStr == "download",
                expression: "item.fileStateStr == 'download'",
              },
            ],
            staticClass: "file-grid-item-state",
          },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("downloading_text")) +
                "，" +
                _vm._s(item.downloadPercent || 0) +
                "% "
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: item.fileStateStr == "import",
                expression: "item.fileStateStr == 'import'",
              },
            ],
            staticClass: "file-grid-item-state",
          },
          [_vm._v(" " + _vm._s(_vm.$t("downloaded")) + " ")]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }